import MeasureSearchDto from '../../Measure/MeasureSearchDto';

export default class MultiMeasureFormDto {
  constructor(options = {}) {
    this.id = options.id || 0;
    this.programId = options.programId || 0;
    this.name = options.name || '';
    this.isActive = options.hasOwnProperty('isActive') ? options.isActive : true;
    this.isSkippable = options.hasOwnProperty('isSkippable') ? options.isSkippable : true;
    this.measures = Array.isArray(options.measures) ? options.measures.map((m) => new MeasureSearchDto(m)) : [];
    this.ExternalId = options.ExternalId || null;
  }

  stringify() {
    return JSON.stringify(this);
  }
}
